import React from 'react';
import PropTypes from 'prop-types';
import { isHomeAcreageMoreThanTwo } from '../../utils/helpers';

export const IncomeAndNetWorthAccordionItem = ({ formData }) => {
  if (formData?.claims?.survivorsPension !== true) {
    return null;
  }

  const is2025Version = formData?.survivorsBenefitsForm2025VersionEnabled;
  const showTotalNetWorth2025 =
    formData?.totalNetWorth === true && is2025Version;
  const showTotalNetWorthLegacy =
    formData?.totalNetWorth === true && !is2025Version;
  const showTransferredAssets = formData?.transferredAssets === true;
  const showHomeAcreage = isHomeAcreageMoreThanTwo(formData);
  const showFiveOrMoreIncomeSources =
    formData?.incomeSourcesCount === 'MORE_THAN_FIVE_SOURCES' && is2025Version;
  const showFourOrMoreIncomeSourcesLegacy =
    formData?.moreThanFourIncomeSources === true && !is2025Version;
  const showOtherIncome = formData?.otherIncome === true;
  const incomeEntriesCount = formData?.incomeEntries?.length || 0;
  const showRequiredDocuments =
    showTotalNetWorth2025 ||
    showTotalNetWorthLegacy ||
    showTransferredAssets ||
    showHomeAcreage ||
    showFiveOrMoreIncomeSources ||
    showFourOrMoreIncomeSourcesLegacy ||
    showOtherIncome;

  return (
    <va-accordion-item level={5} bordered header="Income and net worth">
      {showRequiredDocuments && (
        <div>
          <p>
            Because these circumstances apply to you, you’ll need to submit this
            document:
          </p>
          <ul>
            {showTotalNetWorth2025 && (
              <li className="vads-u-margin-bottom--2">
                There are over $75,000 in assets
              </li>
            )}
            {showTotalNetWorthLegacy && (
              <li className="vads-u-margin-bottom--2">
                There are over $25,000 in assets
              </li>
            )}
            {showTransferredAssets && (
              <li className="vads-u-margin-bottom--2">
                Assets were transferred in the last 3 calendar years
              </li>
            )}
            {showHomeAcreage && (
              <li className="vads-u-margin-bottom--2">
                The primary residence sits on more than 2 acres of land and the
                additional land is marketable
              </li>
            )}
            {showFiveOrMoreIncomeSources && (
              <li className="vads-u-margin-bottom--2">
                There are 5 or more sources of income
              </li>
            )}
            {showFourOrMoreIncomeSourcesLegacy && (
              <li className="vads-u-margin-bottom--2">
                There are 4 or more sources of income
              </li>
            )}
            {showOtherIncome && (
              <li className="vads-u-margin-bottom--2">
                There is income that was received last year that is no longer
                being received
              </li>
            )}
          </ul>
          <p>
            Income and Asset Statement in Support of Claim for Pension or
            Parents' Dependency and Indemnity Compensation (VA Form 21P-0969).
          </p>
          <span className="vads-u-display--block vads-u-margin-bottom--2">
            <va-link
              href="https://www.va.gov/supporting-forms-for-claims/submit-income-and-asset-statement-form-21p-0969"
              text="Submit income and asset statement to support your claim"
              external
            />
          </span>
          <span className="vads-u-display--block">
            <va-link
              href="https://www.va.gov/find-forms/about-form-21p-0969"
              text="Get VA Form 21P-0969 to download"
              external
            />
          </span>
        </div>
      )}
      {incomeEntriesCount >= 4 && (
        <div>
          <p>You may need to submit these documents:</p>
          <p>
            <strong>If you have more than 4 income sources</strong>, you’ll need
            to to submit an Income and Asset Statement in Support of Claim for
            Pension or Parents' Dependency and Indemnity Compensation (VA Form
            21P-0969).
          </p>
          <span className="vads-u-display--block vads-u-margin-bottom--2">
            <va-link
              href="https://www.va.gov/supporting-forms-for-claims/submit-income-and-asset-statement-form-21p-0969"
              external
              text="Submit income and asset statement to support your claim"
            />
          </span>
          <span className="vads-u-display--block">
            <va-link
              href="https://www.va.gov/find-forms/about-form-21p-0969/"
              external
              text="Get VA Form 21P-0969 to download"
            />
          </span>
        </div>
      )}
      {incomeEntriesCount > 0 && (
        <div>
          <p>
            You’ll also need to submit additional evidence for specific types of
            income or assets:
          </p>
          <ul>
            <li className="vads-u-margin-bottom--2">
              <strong>Farm</strong> income or assets require a Pension Claim
              Questionnaire for Farm Income (VA Form 21P-4165)
              <span className="vads-u-display--block">
                <va-link
                  href="https://www.va.gov/find-forms/about-form-21p-4165"
                  external
                  text="Get VA Form 21P-4165 to download"
                />
              </span>
            </li>
            <li className="vads-u-margin-bottom--2">
              <strong>Rental property or business</strong> income or assets
              require a Report of Income from Property or Business (VA Form
              21P-4185)
              <span className="vads-u-display--block">
                <va-link
                  href="https://www.va.gov/find-forms/about-form-21p-4185"
                  external
                  text="Get VA Form 21P-4185 to download"
                />
              </span>
            </li>
            <li className="vads-u-margin-bottom--2">
              <strong>Royalties</strong> require an Income and Asset Statement
              in Support of Claim for Pension or Parents’ Dependency and
              Indemnity Compensation (D.I.C.) (VA Form 21P-0969)
              <span className="vads-u-display--block vads-u-margin-bottom--2">
                <va-link
                  href="https://www.va.gov/supporting-forms-for-claims/submit-income-and-asset-statement-form-21p-0969"
                  external
                  text="Submit income and asset statement to support your claim"
                />
              </span>
              <span className="vads-u-display--block">
                <va-link
                  href="https://www.va.gov/find-forms/about-form-21p-0969/"
                  external
                  text="Get VA Form 21P-0969 to download"
                />
              </span>
            </li>
            <li>
              <strong>Trust</strong> income or assets require you to submit
              complete trust documents, including the schedule of assets
            </li>
          </ul>
        </div>
      )}
    </va-accordion-item>
  );
};

IncomeAndNetWorthAccordionItem.propTypes = {
  formData: PropTypes.object,
};
